var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 6.5C4.66602 5.09987 4.66602 4.3998 4.9385 3.86502C5.17818 3.39462 5.56063 3.01217 6.03104 2.77248C6.56582 2.5 7.26588 2.5 8.66602 2.5H12.3327C13.7328 2.5 14.4329 2.5 14.9677 2.77248C15.4381 3.01217 15.8205 3.39462 16.0602 3.86502C16.3327 4.3998 16.3327 5.09987 16.3327 6.5V17.5L10.4993 14.1667L4.66602 17.5V6.5Z",
    stroke: "#007EF5",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFalse);
export default __webpack_public_path__ + "static/media/save_false.5d24b3c4cc5f55924f0e0b25ed8baf02.svg";
export { ForwardRef as ReactComponent };